import api from "./axios";
import type {
  TrackingStatsResponse,
  TrackingRecordsResponse,
  CompletionCheckResult,
  RecoveryFilters,
} from "types";

export const getStats = (filters?: Partial<RecoveryFilters>) =>
  api.get<TrackingStatsResponse>(
    "/checkout-campaign/recovery/tracking/stats",
    {
      params: {
        ...(filters?.email && { email: filters.email }),
        ...(filters?.completed && { completed: filters.completed }),
        ...(filters?.coupon_used && { coupon_used: filters.coupon_used }),
        ...(filters?.store_name && { store_name: filters.store_name }),
        ...(filters?.date_from && { date_from: filters.date_from }),
        ...(filters?.date_to && { date_to: filters.date_to }),
      },
    }
  );

export const getRecords = (filters: RecoveryFilters) =>
  api.get<TrackingRecordsResponse>(
    "/checkout-campaign/recovery/tracking/records",
    {
      params: {
        ...(filters.email && { email: filters.email }),
        ...(filters.completed && { completed: filters.completed }),
        ...(filters.coupon_used && { coupon_used: filters.coupon_used }),
        ...(filters.store_name && { store_name: filters.store_name }),
        ...(filters.order_status && { order_status: filters.order_status }),
        ...(filters.date_from && { date_from: filters.date_from }),
        ...(filters.date_to && { date_to: filters.date_to }),
        page: filters.page,
        limit: filters.limit,
      },
    }
  );

export const checkCompletions = () =>
  api.post<CompletionCheckResult>(
    "/checkout-campaign/recovery/tracking/check-completions"
  );

export const sendRecoveryByEmail = (
  email: string,
  startDate?: string
) =>
  api.post("/checkout-campaign/recovery/by-email", {
    email,
    ...(startDate && { startDate }),
  });

export interface CheckoutChampOrderDetailResponse {
  success: boolean;
  order: Record<string, unknown>;
}

export const getOrderDetail = (orderId: string) =>
  api.get<CheckoutChampOrderDetailResponse>(
    `/checkout-campaign/orders/${encodeURIComponent(orderId)}`
  );

export interface ChargeOrderPayload {
  /** Only set when retrying a declined order — omitted for a new customer. */
  customerId?: string | number;
  campaignId: number;
  campaignName?: string;
  campaignCategoryName?: string;
  offers: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  companyName?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  shipFirstName?: string;
  shipLastName?: string;
  shipAddress1?: string;
  shipAddress2?: string;
  shipCity?: string;
  shipState?: string;
  shipCountry?: string;
  shipPostalCode?: string;
  couponCode?: string;
  shippingId?: number;
  notes?: string;
  totalAmount?: number;
  // Field names match CheckoutChamp's order/import/ spec.
  cardNumber: string;
  cardMonth: string;
  cardYear: string;
  cardSecurityCode: string;
}

export interface ChargeOrderResponse {
  success: boolean;
  message: string;
  orderId: string;
  /** null when the charge succeeded but the local record could not be saved. */
  orderEntryId: number | null;
}

/**
 * Charges the card and creates the order in one call. Unlike importOrder()
 * this takes payment immediately, so no invoice email is sent afterwards.
 */
export const chargeOrder = (payload: ChargeOrderPayload) =>
  api.post<ChargeOrderResponse>("/checkout-campaign/orders/charge", payload);
